import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import {
  CustomFieldControl,
  DefaultFormFields,
  DynamicFormController,
  FormControl,
} from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { DDARAdditionalContactInformation } from 'types/formService';
import { ReplicatedInfoDelegate } from '../replicatedInfoDelegate';

export type { DDARAdditionalContactInformation };

export interface AdditionalContactInformationFormFields extends DefaultFormFields {
  fullName: FormControl<string>;
  email: FormControl<string>;
  businessPhone: FormControl<string>;
  cellPhone: FormControl<string>;
  toolkitAccess: FormControl<string>;
  onlineEnrollment: FormControl<string>;
}

type ExpectedDynamicController = DynamicFormController<{
  ddarAdditionalContactsInformation: CustomFieldControl<DDARAdditionalContactInformation[]>;
}>;

export class DDARAdditionalContactsInformationDelegate {
  private _dynamicFormController: ExpectedDynamicController;

  public replicatedInfoDelegate: ReplicatedInfoDelegate<
    DDARAdditionalContactInformation,
    AdditionalContactInformationFormFields
  >;

  constructor(dynamicFormController: ExpectedDynamicController) {
    this._dynamicFormController = dynamicFormController;
    this.replicatedInfoDelegate = new ReplicatedInfoDelegate<
      DDARAdditionalContactInformation,
      AdditionalContactInformationFormFields
    >({
      itemFormFields: {
        fullName: new FormControl<string>('', { validations: ['validName'] }),
        email: new FormControl<string>('', { validations: ['isEmailValid'] }),
        businessPhone: new FormControl<string>('', { validations: ['isValidUSAPhoneNumber'] }),
        cellPhone: new FormControl<string>('', { validations: ['isValidUSAPhoneNumber'], optional: true }),
        toolkitAccess: new FormControl<string>(''),
        onlineEnrollment: new FormControl<string>(''),
      },
      syncItemsValue: (items: DDARAdditionalContactInformation[]): void => {
        this._dynamicFormController.populateCustomFields({
          ddarAdditionalContactsInformation: items,
        });
      },
      maxItems: 2,
    });

    const contacts = this._dynamicFormController.getCustomFormFieldsObject().ddarAdditionalContactsInformation ?? [];
    this.replicatedInfoDelegate.populateItems(contacts as DDARAdditionalContactInformation[]);
  }

  public get toolkitUserAccess(): OptionType[] {
    const isToolkitSelected = this._dynamicFormController.getCanonicalAnswers().use_employer_toolkit === 'Yes';
    const options = [{ label: 'None', value: 'None' }];

    if (isToolkitSelected) options.push({ label: 'Bills: View & Pay', value: 'Bills: View & Pay' });

    return options;
  }
}
